import axios from 'axios'

const password_reissue_form = {
  namespaced: true,
  state() {
    return {
      data: {
        email: null,
        managementCompanyCode: localStorage.getItem('managementCompanyCode')
      },
      errors: {},
    }
  },

  getters: {
    parameters(state) {
      return Object.assign({}, state.data);
    },
  },

  mutations: {
    setErrors(state, errors) {
      state.errors = {...errors}
    },
    resetData(state) {
      state.data.email = null
      state.data.managementCompanyCode = localStorage.getItem('managementCompanyCode');
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    send({getters, commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(() => {
          axios.post('/api/brokers/reissue_password', getters.parameters).then(() => {
            commit('setFlashMessage', {value: '送信しました'}, {root: true});
            commit('resetData');
            commit('clearError');
            resolve(true);
          }).catch((error) => {
            let handled = false;
            if (error.response.status === 422) {
              commit('setErrors', error.response.data.errors);
              handled = true;
            }
            reject({handled});
          });
        }).catch(() => reject());
      });
    }
  }
}

export default password_reissue_form;
